import '../../App.css';
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import CommentSection from '../components/CommentSection';
import Footer from '../components/Footer';

function SinglePostPage() {
const { idOrSlug } = useParams();
  const [post, setPost] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);
  const [copySuccess, setCopySuccess] = useState(false);
  const [loading, setLoading] = useState(true); // ✅ add this

  const scrollArticles = (direction) => {
    const container = document.getElementById('articlesWrapper');
    if (container) {
      container.scrollBy({
        left: direction === 'left' ? -300 : 300,
        behavior: 'smooth'
      });
    }
  };
  const apiUrl = process.env.REACT_APP_API_URL ;
  const uploadUrl=process.env.REACT_APP_FOR_UPLOADS_URL
useEffect(() => {
  setLoading(true);

 fetch(`${apiUrl}/posts/resolve/${idOrSlug}`)
    .then(res => {
      if (!res.ok) throw new Error('Post not found');
      return res.json();
    })
    .then(data => {
      setPost(data);
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    });

  fetch(`${apiUrl}/api/posts`)
    .then(res => res.json())
    .then(data => setRecentPosts(data))
    .catch(console.error);

}, [idOrSlug, apiUrl]);


  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading article...</p>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Article not found</p>
      </div>
    );
  }
 // Share functionality
 const shareOnTwitter = () => {
  if (!post) return;
  
  const text = `Check out this article: ${post.title}`;
  const url = window.location.href;
  const hashtags = 'AdmissionsExpress,StudyAbroad,Education';
  
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&hashtags=${hashtags}`;
  
  window.open(twitterUrl, '_blank', 'width=600,height=400,scrollbars=yes,resizable=yes');
};

const shareOnFacebook = () => {
  if (!post) return;
  
  const url = window.location.href;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  
  window.open(facebookUrl, '_blank', 'width=600,height=400,scrollbars=yes,resizable=yes');
};

const shareOnLinkedIn = () => {
  if (!post) return;
  
  const url = window.location.href;
  const title = post.title;
  const summary = post.content.replace(/<[^>]*>/g, '').substring(0, 200) + '...';
  
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}`;
  
  window.open(linkedinUrl, '_blank', 'width=600,height=400,scrollbars=yes,resizable=yes');
};

const copyToClipboard = async () => {
  try {
    const url = window.location.href;
    
    if (navigator.clipboard && window.isSecureContext) {
      // Modern approach
      await navigator.clipboard.writeText(url);
    } else {
      // Fallback approach
      const textArea = document.createElement('textarea');
      textArea.value = url;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    }
    
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  } catch (err) {
    console.error('Failed to copy: ', err);
    // Fallback: show URL in prompt
    prompt('Copy this link:', window.location.href);
  }
};
 // Native Web Share API (for mobile devices)
 const handleNativeShare = async () => {
  if (!post) return;
  
  if (navigator.share) {
    try {
      await navigator.share({
        title: post.title,
        text: post.content.replace(/<[^>]*>/g, '').substring(0, 200) + '...',
        url: window.location.href,
      });
    } catch (err) {
      console.log('Error sharing:', err);
    }
  }
};
  return (
    <>
      <div className="blog-post-layout">
        <main className="blog-main">
          {/* Hero Section */}
          <section className="single-post-hero">
            <div className="hero-content">
              <div className="post-category">
                <span className="category-badge">Blog Article</span>
              </div>
              <h1 className="post-title">{post.title}</h1>
              <div className="post-meta">
                <div className="meta-item">
                  <span className="meta-icon">📅</span>
                  <span className="post-date">{new Date(post.createdAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-icon">✍️</span>
                  <span className="post-author">by {post.author || 'AdmissionsExpress Team'}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-icon">⏱️</span>
                  <span className="read-time">5 min read</span>
                </div>
              </div>
            </div>
            <div className="hero-gradient"></div>
          </section>

          {/* Media Section */}
          {post.coverUrl && (
            <div className="post-media-container">
              {post.mediaType === 'image' ? (
                <img
                  src={`${uploadUrl}${post.coverUrl}`}
                  alt="Article cover"
                  className="blog-post-media"
                />
              ) : (
                <video
                  src={`${uploadUrl}${post.coverUrl}`}
                  controls
                  className="blog-post-media"
                />
              )}
              <div className="media-overlay"></div>
            </div>
          )}

          {/* Content Section */}
          <article className="post-content-wrapper">
            <div className="post-content-container">
              <div
                className="post-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
              
              {/* Social Share */}
              <div className="social-share">
                <h4>Share this article</h4>
                <div className="share-buttons">
                  <button className="share-btn twitter" onClick={shareOnTwitter}>
                    <span className="share-icon">𝕏</span>
                    Twitter
                  </button>
                  <button className="share-btn facebook" onClick={shareOnFacebook}>
                    <span className="share-icon"><i class="fab fa-facebook"></i></span>
                    Facebook
                  </button>
                  <button className="share-btn linkedin" onClick={shareOnLinkedIn}>
                    <span className="share-icon"><i class="fab fa-linkedin"></i></span>
                    LinkedIn
                  </button>
                  <button 
                    className={`share-btn copy ${copySuccess ? 'success' : ''}`} 
                    onClick={copyToClipboard}
                  >
                    <span className="share-icon">{copySuccess ? '✅' : '🔗'}</span>
                    {copySuccess ? 'Copied!' : 'Copy Link'}
                  </button>
                  
                  {/* Native Share Button (shows only on supported devices) */}
                  {navigator.share && (
                    <button className="share-btn native" onClick={handleNativeShare}>
                      <span className="share-icon">📤</span>
                      Share
                    </button>
                  )}
                </div>
                
                {/* Share Stats (Optional) */}
                <div className="share-stats">
                  <p>Help others discover this article by sharing it!</p>
                </div>
              </div>
            </div>
          </article>

          {/* Comments Section */}
          <CommentSection postId={post.id} />

          {/* Recent Articles Section */}
          <section className="recent-articles">
            <div className="section-header">
              <h2>Continue Reading</h2>
              <p>Discover more insights and stories</p>
            </div>

            <div className="articles-container">
              <div id="articlesWrapper" className="articles-wrapper">
                {recentPosts
                  .filter(p => p.id !== post.id)
                  .slice(0, 3)
                  .map(p => (
                    <div key={p.id} className="article-card">
                      <div className="card-content">
                        <div className="card-header">
                          <span className="card-date">
                            {new Date(p.createdAt).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric'
                            })}
                          </span>
                        </div>
                        <h3 className="card-title">{p.title}</h3>
                        <p className="card-excerpt" 
                           dangerouslySetInnerHTML={{ 
                             __html: p.content.replace(/<[^>]*>/g, '').substring(0, 120) + '...' 
                           }} 
                        />
<Link to={`/post/${p.slug}`} className="article-btn">
                          <span>Read Article</span>
                          <span className="btn-arrow">→</span>
                        </Link>
                      </div>
                      <div className="card-gradient"></div>
                    </div>
                  ))}
              </div>

              <div className="carousel-controls">
                <button 
                  className="carousel-btn prev" 
                  onClick={() => scrollArticles('left')}
                  aria-label="Previous articles"
                >
                  <span>←</span>
                </button>
                <button 
                  className="carousel-btn next" 
                  onClick={() => scrollArticles('right')}
                  aria-label="Next articles"
                >
                  <span>→</span>
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </>
  );
}

export default SinglePostPage;

